import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DataStudioWsModule } from './lib/lds-websocket-module/data-studio-ws.module';
import { DataAnalyticsModule } from './lib/data-analytics.module';
import { NgLwDataStudioModule } from './lib/ng-lw-data-studio.module';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginAsComponent } from './login-as/login-as.component';

@NgModule({ 
    declarations: [
        AppComponent,
        LoginComponent,
        LoginAsComponent,
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        DataStudioWsModule.forRoot({
            url: "wss://v1-linkplus-app.lightwaverf.com"
        }),
        DataAnalyticsModule.forRoot({
            url: 'https://publicapi.lightwaverf.com/v3/data/pass',
            apiKey: 'use access token'
        }),
        NgLwDataStudioModule
    ], 
    providers: [
        {
            provide: MatDialogRef,
            useValue: {}
        }, 
        provideHttpClient(withInterceptorsFromDi())
    ] 
})
export class AppModule { }
